import { useSelector } from 'react-redux';
import * as Yup from 'yup';
import { BookingSelectors } from '../../../redux/reducers/bookingSlice';
import {
  FACEBOOK_REG,
  INSTAGRAM_REG,
  REQUIRED_FIELD_ERROR,
  TELEGRAM_REG,
  TELEPHONE_ERROR,
  TOTAL_INFO_ERROR,
  VKONTAKTE_REG,
} from '../../../utils/constants';

const useSocialValidationSchema = () => {
  const isValid = useSelector(BookingSelectors.getIsTelephoneValid);

  const socialValidationSchema = Yup.object().shape({
    telegram: Yup.string()
      .notRequired()
      .matches(TELEGRAM_REG, TOTAL_INFO_ERROR)
      .max(32, 'Максимальное количество знаков 32'),

    viber: Yup.object().shape({
      country_code: Yup.string(),
      phone_code: Yup.string(),
      phone_number: Yup.string()
        .required(REQUIRED_FIELD_ERROR)
        .test('is-valid-phone', TELEPHONE_ERROR, function (value) {
          return !isValid;
        }),
    }),

    vk: Yup.string().matches(VKONTAKTE_REG, TOTAL_INFO_ERROR).notRequired(),

    facebook: Yup.string()
      .matches(FACEBOOK_REG, TOTAL_INFO_ERROR)
      .notRequired(),

    instagram: Yup.string()
      .matches(INSTAGRAM_REG, TOTAL_INFO_ERROR)
      .notRequired(),
  });
  return socialValidationSchema;
};

export default useSocialValidationSchema;
